import { render } from "./icon.vue?vue&type=template&id=297d91bf&scoped=true&ts=true"
import script from "./icon.vue?vue&type=script&lang=ts"
export * from "./icon.vue?vue&type=script&lang=ts"

import "./icon.vue?vue&type=style&index=0&id=297d91bf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297d91bf"]])

export default __exports__